import { RedoClient } from "@redotech/redo-api-client";
import { FeesErrorDescription } from "@redotech/redo-storefront-common/config/errors";
import { WidgetFees } from "@redotech/redo-storefront-widget-common/widget";
import {
  getLocalStorageWithExpiry,
  setLocalStorageWithExpiry,
} from "@redotech/redo-web/utils/local-storage-wrapper";
import {
  getFees,
  ShopifyExtensionClient,
} from "./client/shopify-extension-client";
import { getRedoStorefrontConfig } from "./config";
import { feesErrorToCoverageNotShowingReason } from "./storefront-debugger/coverage-debug-init";

let widgetFeesPromise: Promise<WidgetFees> | null = null;

const FEE_CACHE_KEY = "redo_fees";

function getFeesPromise(): Promise<WidgetFees> {
  const redoClient = new RedoClient(
    globalThis.redoStorefront?.env?.REDO_API_URL ?? process.env.REDO_API_URL!,
  );
  const client = new ShopifyExtensionClient(
    redoClient,
    globalThis.redoWidgetId,
    getRedoStorefrontConfig().storeUrl,
  );

  widgetFeesPromise = getFees(client);
  return widgetFeesPromise;
}

async function refreshFeesCache() {
  const fees = widgetFeesPromise
    ? await widgetFeesPromise
    : await getFeesPromise();
  setLocalStorageWithExpiry(FEE_CACHE_KEY, fees, 0.5);
}

export async function getFeesCache(): Promise<WidgetFees> {
  const storedFees = getLocalStorageWithExpiry(FEE_CACHE_KEY);
  if (storedFees) {
    void refreshFeesCache();
    return storedFees;
  }

  if (widgetFeesPromise === null) {
    widgetFeesPromise = getFeesPromise();
  }

  try {
    const fees = await widgetFeesPromise;
    setLocalStorageWithExpiry(FEE_CACHE_KEY, fees, 0.1);
    return fees;
  } catch (error) {
    const errorMessage = (error as any)?.response?.data?.error;
    if (
      typeof errorMessage === "string" &&
      Object.values(FeesErrorDescription).includes(
        errorMessage as FeesErrorDescription,
      )
    ) {
      if (globalThis.redoStorefront) {
        const reason =
          feesErrorToCoverageNotShowingReason[
            errorMessage as FeesErrorDescription
          ];
        console.log({ reason });
        globalThis.redoStorefront.coverageNotShowingReason = reason;
      }
    } else if (globalThis.redoStorefront) {
      globalThis.redoStorefront.coverageNotShowingReason = "FEES_ERROR";
    }
    widgetFeesPromise = null;
    throw error;
  }
}
